import { render, staticRenderFns } from "./ArcadeFiles.vue?vue&type=template&id=eded3260&"
import script from "./ArcadeFiles.vue?vue&type=script&lang=js&"
export * from "./ArcadeFiles.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports